import { animate, animation, style } from '@angular/animations';

export const FadeInConfig = animation([
  style({ opacity: 0, transform: '{{ init }}' }),
  animate('{{ time }}', style({ opacity: 1, transform: '{{ translate }}' })),
]);

export const FadeOutConfig = animation([
  style({ opacity: 1 }),
  animate('{{ time }}', style({ opacity: 0, transform: '{{ translate }}' })),
]);
